import React from 'react';
import { useSelector } from 'react-redux';
import { LoadingImage } from '@tradingblock/components';
import { accountBalances } from '../../data/global/dataSelectors';
import { AccountBalanceView } from './AccountBalanceView';

export const AccountContent: React.FunctionComponent<{}> = () => {
  const totals = useSelector(accountBalances.totals);
  const isFetching = useSelector(accountBalances.isFetching);

  if (!totals) {
    return isFetching ? <LoadingImage /> : null;
  }
  return <>{totals && <AccountBalanceView totals={totals} />}</>;
};
